import { PinComponentId, PinId } from '@lessonup/pins-shared';
import {
  getComponentColors,
  getInputFieldBorderAndColorStyles,
  getInputFieldFontStyles,
  inputFieldPaddingSize,
  InputLabel,
  inputLineHeightMap,
  SpaceBetween,
  spacing,
  spacingScaled,
  styled,
} from '@lessonup/ui-components';
import React, { CSSProperties } from 'react';
import { TipTapInput } from '../../../../utils/yjs/TipTapInput';

export interface EditorTiptapInputProps {
  pinId: PinId;
  pinComponentId: PinComponentId;
  fragmentKey: string;
  isTextArea?: boolean;
  label?: string;
  placeholder?: string;
  height?: string;
  useBaseExtensions?: boolean;
}

interface InputWrapperCssProperties extends CSSProperties {
  '--tiptap-input-height': CSSProperties['height'];
  '--tiptap-input-overflow': CSSProperties['overflow'];
}

export const EditorTiptapInput: React.FC<EditorTiptapInputProps> = ({
  pinId,
  pinComponentId,
  fragmentKey,
  isTextArea,
  label,
  height,
  placeholder,
  useBaseExtensions,
}) => {
  const style: InputWrapperCssProperties = {
    '--tiptap-input-height': height
      ? height
      : isTextArea
        ? `calc(${INPUT_HEIGHT} * ${TEXT_AREA_ROWS})`
        : `${INPUT_HEIGHT}`,
    '--tiptap-input-overflow': isTextArea ? 'auto' : 'hidden',
  };
  return (
    <SpaceBetween direction="y" spacing={spacing.size2} size="medium">
      {label && <InputLabel size="medium">{label}</InputLabel>}
      <InputWrapperStyle style={style} isTextArea={isTextArea}>
        <TipTapInput
          pinId={pinId}
          pinComponentId={pinComponentId}
          fragmentKey={fragmentKey}
          disableNewLine={!isTextArea}
          placeholder={placeholder}
          useBaseExtensions={useBaseExtensions}
        />
      </InputWrapperStyle>
    </SpaceBetween>
  );
};

const INPUT_HEIGHT = inputLineHeightMap.medium;
const TEXT_AREA_ROWS = 4;

const InputWrapperStyle = styled.div<{ isTextArea?: boolean }>`
  ${getInputFieldBorderAndColorStyles(getComponentColors('neutral'), 'medium')};
  padding: ${spacingScaled(inputFieldPaddingSize, 'medium')};
  overflow: auto;

  .ProseMirror {
    ${getInputFieldFontStyles('medium')};
    height: var(--tiptap-input-height);
    overflow: var(--tiptap-input-overflow);
  }

  p {
    margin: 0;
    padding: 0 ${spacingScaled(spacing.size2, 'medium')};
  }
`;
